import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';
import { formatAmount } from 'src/utils/formatAmout';
import { useSelector } from 'react-redux';
import { selectCFDISQueryOptions } from 'src/store/selectors/cfdiSelectors';

const WithholdingsRow = ({
  period,
  dividends,
  otherWithholdings,
  total
}) => {
  const { period: periodType } = useSelector(selectCFDISQueryOptions);

  return (
    <TableRow hover align="center">
      <TableCell
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
        align="center"
      >
        {selectFormatDate(
          period,
          periodType === dateFormatType.YEAR
            ? dateFormatType.YEAR
            : dateFormatType.MONTH
        )}
      </TableCell>
      <TableCell align="center">{formatAmount(dividends)}</TableCell>
      <TableCell align="center">{formatAmount(otherWithholdings)}</TableCell>
      <TableCell align="center">{formatAmount(total)}</TableCell>
    </TableRow>
  );
};

WithholdingsRow.propTypes = {
  period: PropTypes.string,
  dividends: PropTypes.number,
  otherWithholdings: PropTypes.number,
  total: PropTypes.number
};

export default WithholdingsRow;
